module.exports = __webpack_public_path__ + "img/fi-rr-shopping-cart-check.cb4b452e.svg";